import { AvailableTabs } from 'constants/SidebarTabs';
import { TMSHost } from 'lib/hosts/tms/interface';
import { Dropoff, NormalizedLoad, Pickup } from 'types/Load';
import { Maybe } from 'types/UtilityTypes';

export class QuantumEdge implements TMSHost {
  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return ''; // TODO
      case 'freightTrackingID':
        return 'Load ID';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    const urlMatch = window.location.href.match(/shipment_id=(\d+)/);
    if (urlMatch) {
      return urlMatch[1];
    }

    return '';
  }

  // ExternalTMSID = FreightTrackingID for Aljex
  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  parsePickup(): Maybe<Pickup> {
    return null;
  }

  parseDropoff(): Maybe<Dropoff> {
    return null;
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    // For list view URL (*.edgetms.com/module/?key=shipment_adv&*)
    // and details view (*.edgetms.com/index.cfm?display_menu=0&action=shipment_main&shipment_id=714291)
    return window.location.href.includes('shipment');
  }
}
